<template>
  <div
    class="card"
    data-test="widgetCard"
  >
    <header class="card-header">
      <p
        slot="header"
        class="card-header-title"
      >
        {{ heading }}
      </p>
      <a
        class="card-header-icon"
        href="#"
        @click.prevent="showInfo = !showInfo"
      >
        <span class="icon">
          <font-awesome-icon icon="info-circle" />
        </span>
      </a>
    </header>
    <div class="card-content">
      <div class="content">
        <transition name="fade-slide">
          <div
            v-show="showInfo"
            :id="id"
            class="info"
          >
            <div class="body">
              <slot name="explanation" />
            </div>
          </div>
        </transition>
        <p class="card-text">
          <slot />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'DashboardWidget',
  props: {
    heading: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showInfo: false
    }
  }
}
</script>

<style lang="scss" scoped>

.card {
  margin-bottom: 15px;
}
.icon-info {
  cursor: pointer;
}
.card-header {
  background-color: #eeeeee;
}

.card-content {
  justify-content: center;
  align-items: center;
  display: flex;
  height: calc(100% - 39px);

  .content {
    flex: 1;
  }
}

.info {
  .body {
    margin-bottom: 20px;
  }
}

</style>
